export const Types = {
  GET_DEFECT_REQUEST: 'GET_DEFECT_REQUEST',
  GET_DEFECT_SUCCESS: 'GET_DEFECT_SUCCESS',
  SET_DEFECT_ERROR: 'SET_DEFECT_ERROR',
  SET_SELECTION: 'SET_SELECTION',
  SET_DEFECT_FILTER_KEY: 'SET_DEFECT_FILTER_KEY',
  SET_CURRENT_DEFECT: 'SET_CURRENT_DEFECT',
  RESET_DEFECTS: 'RESET_DEFECTS',
  ADD_DEFECTS: 'ADD_DEFECTS',
}

export const getDefectRequest = (kulModelKodu, garantiTipi, isEcomReturn) => ({
  type: Types.GET_DEFECT_REQUEST,
  kulModelKodu,
  garantiTipi,
  isEcomReturn,
});

export const resetDefects = () => ({
  type: Types.RESET_DEFECTS,
});

export const addDefects = (defects) => ({
  type: Types.ADD_DEFECTS,
  payload: { defects },
});

export const getDefectSuccess = (response) => ({
  type: Types.GET_DEFECT_SUCCESS,
  payload: response,
});

export const setDefectError = (error) => ({
  type: Types.SET_DEFECT_ERROR,
  payload: { error }
});

export const setSelection = (item) => {
  return ({
    type: Types.SET_SELECTION,
    payload: { item }
  })
};

export const setDefectFilterKey = (value) => {
  return ({
    type: Types.SET_DEFECT_FILTER_KEY,
    payload: { value }
  })
};

export const setCurrentDefect = (value) => {
  return ({
    type: Types.SET_CURRENT_DEFECT,
    payload: { value }
  })
};